import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 520,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(7, 0),
}));

// ----------------------------------------------------------------------

export default function UnderConstruction() {
  return (
    <>
      <Helmet>
        <title> Samaaro Showcase </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Sorry, Website is Under Construction
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            We can't navigate you to the Dashbaord Page as It is being optimised for the best user experience.
          </Typography>

          <Box
            component="img"
            src="/assets/icons/under-construction.png"
            sx={{ height: 240, mx: 'auto', my: { xs: 3 } }}
          />

          <Button to="/user/login" size="large" variant="contained" component={RouterLink}>
            Go to Login Page
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
